import { InputNumber } from "antd"
import style from "./NumberInputRow.module.scss"

const { row, labelGroup, label, requiredMark, inputWrapper, numberInput } = style

type Props = {
	label: string
	required?: boolean
	value: number | null
	onChange: (value: number | null) => void
	onBlur?: () => void
	disabled?: boolean
	min?: number
	max?: number
}

export const NumberInputRow = ({
	label: labelText,
	required = false,
	value,
	onChange,
	onBlur,
	disabled = false,
	min = 0,
	max,
}: Props) => {
	return (
		<div className={row}>
			<div className={labelGroup}>
				<span className={label}>{labelText}</span>
				{required ? <span className={requiredMark}>*</span> : null}
			</div>
			<div className={inputWrapper}>
				<InputNumber
					className={numberInput}
					value={value}
					onChange={(v) => onChange(typeof v === "number" ? v : null)}
					onBlur={onBlur}
					onPressEnter={onBlur}
					disabled={disabled}
					min={min}
					max={max}
					controls={false}
				/>
			</div>
		</div>
	)
}
